<template>
  <div class="dialog" v-if="$store.state.pageLoaded">
    <md-dialog-confirm :md-active.sync="$store.state.dialogs.delete"
                md-title="Brisanje pretplatnika"
                md-content="Jeste li sigurni?"
                md-confirm-text="Obriši"
                md-cancel-text="Zatvori"
                v-on:md-confirm="deleteSubscriber"
                >
    </md-dialog-confirm>
    <md-dialog :md-active.sync="$store.state.dialogs.edit" v-on:md-closed="clearForm" class="edit-form md-scrollbar">
      <md-dialog-title>{{ getDialogTitle() }}</md-dialog-title>
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <md-field :class="messageClass('first_name', $store.state.selectedObject)">
              <label>Ime</label>
              <md-input required type="text" name="first_name" v-model="$store.state.selectedObject.first_name"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('last_name', $store.state.selectedObject)">
              <label>Prezime</label>
              <md-input required type="text" name="last_name" v-model="$store.state.selectedObject.last_name"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
             <md-field>
              <label>Datum rođenja</label>
              <md-input type="date" name="birthday" v-model="$store.state.selectedObject.birthday"/>
	      <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('address', $store.state.selectedObject)">
              <label>Adresa</label>
              <md-input required type="text" name="address" v-model="$store.state.selectedObject.address"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('city', $store.state.selectedObject)">
              <label>Grad</label>
              <md-input required type="text" name="city" v-model="$store.state.selectedObject.city"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('postal_code', $store.state.selectedObject)">
              <label>Poštanski broj</label>
              <md-input required type="text" name="postal_code" v-model="$store.state.selectedObject.postal_code"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field>
              <label>Broj telefona</label>
              <md-input type="text" name="phone" v-model="$store.state.selectedObject.phone"/>
            </md-field>
            <md-field :class="messageClass('mobile_phone', $store.state.selectedObject)">
              <label>Broj mobitela</label>
              <md-input type="text" name="mobile_phone" v-model="$store.state.selectedObject.mobile_phone"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field>
              <label>Broj poslovnog telefona</label>
              <md-input type="text" name="work_phone" v-model="$store.state.selectedObject.work_phone"/>
            </md-field>
            <md-field :class="messageClass('email', $store.state.selectedObject)">
              <label>Email</label>
              <md-input type="email" name="email" v-model="$store.state.selectedObject.email"/>
              <span class="md-error">Unesite ispravan email</span>
            </md-field>
          </div>
          <md-dialog-actions>
            <md-button v-on:click="$store.state.dialogs.edit = false">Zatvori</md-button>
            <md-button v-on:click="updateOrCreateSubscriber" class="md-primary">Spremi</md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-card>
    </md-dialog>
  </div>
</template>

<script>
import SubscriberValidation from '../../../mixins/subscriber-validator.js';
export default {
  name: 'SubscribersDialog',
  mixins: [SubscriberValidation],

  created(){
    this.requiredFields = ['first_name', 'last_name', 'city', 'address', 'postal_code'];
  },

  methods: {
    getDialogTitle(){
      let title = '';
      if(this.$store.state.dialogs.add) title = 'Dodaj pretplatnika'
      else if(this.$store.state.dialogs.edit) title = 'Uredi pretplatnika'
      return title;
    },

    async updateOrCreateSubscriber(){
      this.formSubmitted();
      let stateObject = 'subscribers';
      let selectedObject = 'selectedObject';
      if(this.passed){
        if(this.$store.state.selectedObject.birthday==""){
          this.$store.state.selectedObject.birthday = null;
        }
        if(this.$store.state.dialogs.add){
          await this.$store.dispatch('manipulateData', {type: 'postSelectedData', stateObject, selectedObject})
        } else if(this.$store.state.dialogs.edit){
          await this.$store.dispatch('manipulateData', {type: 'updateSelectedData', stateObject, selectedObject})
        }
        if(this.$store.state.errors.length === 0){
          this.$store.state.dialogs.add = false;
          this.$store.state.dialogs.edit = false;
          this.submited = false;
        }
      }
    },

		deleteSubscriber(){
			let stateObject = 'subscribers';
      let selectedObject = 'selectedObject';
      this.$store.dispatch('manipulateData', {type: 'deleteSelectedData', stateObject, selectedObject})
		},
  },
}
</script>
<style lang="scss">
input[type="date"]:in-range::-webkit-datetime-edit-year-field, 
input[type="date"]:in-range::-webkit-datetime-edit-month-field, 
input[type="date"]:in-range::-webkit-datetime-edit-day-field, 
input[type="date"]:in-range::-webkit-datetime-edit-text {
    color: transparent!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Subscriptions/SubscribersDialog.vue